// The page's top bar on a phone (Josh 10-02: "interfaces on non xr are very cramped"): with every control a full
// 44 px target there is no room in one bar for ‹ the window › and Snap · Look · VR and ⋯, so under the phone width
// (tokens screen.phoneBelow) the view choices move to the top of the ⋯ sheet, as one segmented row; the bar keeps the
// window's name with ‹ ›, Close while a stream is in front, and ⋯. Wider, they go back into the bar. The pills keep
// their own listeners (app.js, core/xr-button.js) wherever they stand. Choosing a view, or anything in the sheet that
// does something once (Connect, Install, the log, Close), closes the sheet as it acts (Josh 10-02: "clicking snap or
// look buttons should close the dropdown menu"); a setting (the frame rate, Relay only) leaves it open.
//
// The sheet's Appearance row (Match device · Light · Dark) is core/appearance.js's, placed here with the rest.
//
// One seam: `screenBar()` — once, from core/render-dom.js.
import { SCREEN } from './tokens.js'
import { screenA11y } from './screen-a11y.js'
import { appearanceRow } from './appearance.js'

/// What in the ⋯ sheet acts once: the view choices (Snap, Look, VR / AR), Connect, Install, the build line (the log).
export const ONE_SHOT = '[data-mode], .xr, #connect, #install, #build, #sheet-close'

export function screenBar() {
  const modes = document.getElementById('modes'), sheet = document.getElementById('sheet')
  if (!modes || !sheet || modes.__screenBar) return
  modes.__screenBar = true
  const row = document.createElement('div')
  row.id = 'sheet-modes'
  row.setAttribute('role', 'group')
  row.setAttribute('aria-label', 'View')
  row.innerHTML = '<p class="head">View</p><div class="seg-row"></div>'
  sheet.prepend(row)
  appearanceRow(sheet)
  const holder = row.querySelector('.seg-row')
  const phone = matchMedia(`(max-width: ${SCREEN.phoneBelow - 0.02}px)`)
  const place = () => {
    const pills = [...modes.children, ...holder.children].filter((el) => el.id !== 'close-stream')
    if (phone.matches) for (const p of pills) { if (p.parentElement !== holder) holder.appendChild(p) }
    else for (const p of pills) { if (p.parentElement !== modes) modes.appendChild(p) }
    row.hidden = !phone.matches
  }
  screenA11y(sheet)   // the build line is a button too
  // after the choice's own listener (bubbling to the sheet): the sheet goes
  sheet.addEventListener('click', (e) => {
    if (e.target.closest?.(ONE_SHOT)) { sheet.hidden = true; document.getElementById('more')?.setAttribute('aria-expanded', 'false') }
  })
  phone.addEventListener('change', place)
  // the VR / AR pill arrives later (core/xr-button.js appends it to the bar)
  new MutationObserver(() => { if (phone.matches && [...modes.children].some((el) => el.id !== 'close-stream')) place() }).observe(modes, { childList: true })
  place()
}
